export default "/images/763098aeb9face080fed0bdceb7242d9.avif";